import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { ToastrService } from 'ngx-toastr';
import { CardService } from 'app/modules/card/services/card.service';


@Component({
  selector: 'xplorer-feature',
  templateUrl: './xplorer-feature.component.html',
  styleUrls: ['./xplorer-feature.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class XplorerCardFeatureComponent implements OnInit {


   public showLoader: boolean = false;
    isChecked: boolean = false; 
  
    
    public menuItems = [
      {
        'icon': 'xp-feature1.png',
        'title': '30 multi-currency wallets with zero cross-currency fee',
        'url': '',
      },
      {
        'icon': 'xp-feature2.png',
        'title': 'Metal Pre-Paid Global Card',
        'url': '',
      },
      {
        'icon': 'xp-feature3.png',
        'title': 'Zero Cost on Global Wallet Transfers',
        'url': '',
      },
      {
        'icon': 'xp-feature4.png',
        'title': 'Zero ATM Withdrawal Fee',
        'url': '',
      },
      {
        'icon': 'xp-feature5.png',
        'title': '4 Global Lounge Pass – Annually',
        'url': '',
      },
      {
        'icon': 'xp-feature6.png',
        'title': 'Global SIM Included',
        'url': '',
      },
      {
        'icon': 'xp-feature7.png',
        'title': 'App-Enabled Control',
        'url': '',
      },
      {
        'icon': 'xp-feature8.png',
        'title': 'Real-Time Alerts',
        'url': '',
      },
      {
        'icon': 'xp-feature9.png',
        'title': 'Advanced Chip Security',
        'url': '',
      },
        {
        'icon': 'xp-feature10.png',
        'title': '24/7 Global Assistance',
        'url': '',
      },
        {
        'icon': 'xp-feature11.png',
        'title': 'Pay-Per-Use Privilege',
        'url': '',
      },
        {
        'icon': 'xp-feature12.png',
        'title': 'Instant Travel Insurance',
        'url': '',
      },
    ];
  
   
    public esimItems = [
      {
        'icon': 'spec1.png',
        'title': 'Activation',
        'text': ' Automatic, activated when connected to a cellular network.',
        'url': '',
      },
  
      {
        'icon': 'spec6.png',
        'title': 'Tethering / Hotspot',
        'text': 'Yes depending on local Operator policy',
        'url': '',
      },
  
      {
        'icon': 'spec3.png',
        'title': 'Installation',
        'text': 'Scan a QR code.',
        'url': '',
      },
      {
        'icon': 'spec4.png',
        'title': 'Plan Type',
        'text': 'Data Prepaid',
        'url': '',
      },
  
      {
        'icon': 'spec7.png',
        'title': 'Technology',
        'text': ': eSIM',
        'url': '',
      },
  
      {
        'icon': 'spec8.png',
        'title': 'Speed',
        'text': '4G /5G',
        'url': '',
      },
      
      {
        'icon': 'spec2.png',
        'title': 'Activation Policy',
        'text': 'The validity period begins upon eSIM connection to a supported network.',
        'url': '',
      },
    
     
     
      {
        'icon': 'spec5.png',
        'title': 'Other',
        'text': 'FUP Policy applicable for Unlimited Plans per Day 1GB at Network provided speed and post 1GB it will throttle to 265kbps speed.',
        'url': '',
      },
    
     
  
    ];
  
  
    public activeTab: string = "";
  
    constructor(
      public router: Router,
      public toast: ToastrService,
      private _location: Location,
      public cardService: CardService
    ) { }
  
    ngOnInit(): void {
     
    }
    setActiveTab(tabIndex: string) {
      this.activeTab = tabIndex;
    }
    
    proceedToNextPage(pageUrl: string): void {
      this.router.navigate([pageUrl]);
    }
  
  
   /* onCheckboxChange() {
      console.log('Checkbox state:', this.isChecked);
    }
  
    claimNow() {
      let isStudentPayCard = sessionStorage.getItem(ConstantsKey.IS_STUDENT_PAY_CARD);
  
      if(isStudentPayCard) {
        this.proceedToESim(isStudentPayCard)
      } else {
        this.getAllCards();
      }
    }
  
    goToNewFeatures() {
      this._location.back();
    }
    
    getAllCards() {
      this.cardService.getAllCardDetail().subscribe(resp => {
        let cardList:any = resp.body;
        const isStudentPay = cardList.some(el => el.cardVendor === "WSFXSTUDENTSCC");
        if(isStudentPay) {
          this.proceedToESim("true");
          sessionStorage.setItem(ConstantsKey.IS_STUDENT_PAY_CARD, "true");
        } else {
          this.proceedToESim("false");
        }
  
  
  
      }, err => {
        this.showLoader = false;            
      });    
    }
  
    proceedToESim(isStudentPayCard) {
      if(this.isChecked) {
        if(isStudentPayCard && isStudentPayCard == 'true') {
          // this.toast.success('Coming soon!');
          this.router.navigate(["/international-esim"]);      
        } else {
          this.toast.error("Sorry! You do not have Student Pay Card");
        }
      } else {
        this.toast.error("Please accept terms and condition");
      }
    }*/
  
  }
  